var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded && _vm.showMinimalHeader)?_c('NsMinimalHeader',_vm._b({},'NsMinimalHeader',_vm.$props,false)):_vm._e(),(_vm.loaded && !_vm.showMinimalHeader)?_c('NsHeaderAem',_vm._b({},'NsHeaderAem',_vm.$props,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }